import CookiesPopover from './cookies_popover';

export default CookiesPopover;
